import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { template } from 'lodash-es';
import { IconsEnum } from '@uigy/generated/icons.enum';

interface StepTexts {
  active: string;
  active_btn: string;
  visited?: string;
  visited_btn?: string;
}

interface LinkStepTexts extends StepTexts {
  link: string;
  link_url: string;
  link_2: string;
  link_2_url: string;
}

@Component({
    selector: 'app-step-box',
    templateUrl: './step-box.component.html',
    styleUrls: ['./step-box.component.scss'],
    standalone: false
})
export class StepBoxComponent implements OnInit {
  protected readonly IconsEnum = IconsEnum;
  @Input() stepNumber: number = 0;
  @Input() activeStep: number = 0;
  @Input() stepTexts?: StepTexts | LinkStepTexts;
  @Input() design?: 'settings' | 'activation';

  @Output() activeClick = new EventEmitter<void>();
  @Output() visitedClick = new EventEmitter<void>();

  public descActive?: string;
  public descVisited?: string;

  get isActive(): boolean {
    return this.stepNumber === this.activeStep;
  }

  get isVisited(): boolean {
    return this.stepNumber < this.activeStep;
  }

  constructor() {
  }

  ngOnInit(): void {
    this.getDesc();
  }

  private getDesc() {
    if (!this.stepTexts) {
      return;
    }

    if ('link' in this.stepTexts) {
      const link = `<a href="${this.stepTexts.link_url}" target="_blank">${this.stepTexts.link}</a>`;
      const link_2 = `<a href="${this.stepTexts.link_2_url}" target="_blank">${this.stepTexts.link_2}</a>`;
      this.descActive = template(this.stepTexts.active)({link, link_2});

      if (this.stepTexts.visited) {
        this.descVisited = template(this.stepTexts.visited)({link, link_2});
      }
    } else {
      this.descActive = this.stepTexts.active;
      this.descVisited = this.stepTexts.visited;
    }
  }
}
